import { Components, Theme, ThemeOptions } from '@mui/material/styles';

export const DIALOGUE_SIZE_MAP: Record<
  string,
  { maxWidth: string; maxHeight: string; width?: string; height?: string }
> = {
  s: { maxWidth: '40vw', maxHeight: '50vh', width: '90%', height: 'auto' },
  md: { maxWidth: '52vw', maxHeight: '70vh', width: '90%', height: 'auto' },
  lg: { maxWidth: '80vw', maxHeight: '80vh', width: '100%', height: 'auto' },
  xl: { maxWidth: '95vw', maxHeight: '90vh', width: '100%', height: 'auto' },
};

const getDialogueTheme = (theme: Theme): ThemeOptions => {
  const dialogTheme: Components<Theme>['MuiDialog'] = {
    styleOverrides: {
      paper: {
        backgroundColor: theme.palette.M3.sys.light.surface,
        borderRadius: theme.unit(4), // 16px
        boxShadow: theme.shadows[4],
        padding: theme.unit(6, 8),
        display: 'flex',
        flexDirection: 'column',
        gap: theme.unit(6),
        maxWidth: DIALOGUE_SIZE_MAP.md.maxWidth,
        maxHeight: DIALOGUE_SIZE_MAP.md.maxHeight,
        width: DIALOGUE_SIZE_MAP.md.width,
        height: DIALOGUE_SIZE_MAP.md.height,
        margin: 0,
      },
    },
  };

  const dialogTitleTheme: Components<Theme>['MuiDialogTitle'] = {
    styleOverrides: {
      root: {
        padding: 0,
        ...theme.typography.M3.headline.small,
        color: theme.palette.M3.sys.light['on-primary-fixed'],
      },
    },
  };

  const dialogContentTheme: Components<Theme>['MuiDialogContent'] = {
    styleOverrides: {
      root: {
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: theme.unit(6), // 24px
        overflow: 'auto',
      },
    },
  };

  const dialogActionsTheme: Components<Theme>['MuiDialogActions'] = {
    styleOverrides: {
      root: {
        padding: 0,
        display: 'flex',
        justifyContent: 'space-between',
        gap: theme.unit(2), // 8px
      },
    },
  };

  return {
    components: {
      MuiDialog: dialogTheme,
      MuiDialogTitle: dialogTitleTheme,
      MuiDialogContent: dialogContentTheme,
      MuiDialogActions: dialogActionsTheme,
    },
  };
};

export default getDialogueTheme;
